module.exports = __webpack_public_path__ + "img/member_shopping_online_icon_431003.33a7887f.jpg";